import { requiresStampValidation } from '../features/documents/documentService';

/**
 * Convert backend stamp validation fields to frontend status
 * @param {Object} document - Document object with backend fields
 * @returns {string} - 'VALID', 'INVALID', or 'PENDING'
 */
export const getStampValidationStatus = (document) => {
  if (!document) return 'PENDING';
  
  if (document.stampValidatedAt) {
    return document.stampValid ? 'VALID' : 'INVALID';
  }
  
  return 'PENDING';
};

/**
 * Check if document can be validated by current user
 * @param {Object} document - Document object
 * @param {boolean} isClaimsOfficer - Whether user is claims officer
 * @param {boolean} isApprover - Whether user is approver  
 * @returns {boolean} - Whether validation button should be shown
 */
export const canValidateDocument = (document, isClaimsOfficer, isApprover) => {
  if (!document) return false;
  
  // Must be Claims Officer or Approver
  if (!isClaimsOfficer && !isApprover) return false;
  
  // Document must require stamp validation
  if (!requiresStampValidation(document.type)) return false;
  
  // Cannot validate already valid documents
  if (document.stampValid === true) return false;
  
  return true;
};
